import React from "react";
import { Spinner } from "grommet";
import { Box, DownloadIconWMO, IcoMoon, Text } from "@usap/uicomponents";
import styled from "styled-components";

const DownloadInvoiceButton = ({ loading = false, buttonStyle, onClick }) => {
  const PrintInvoiceBox = styled(Box)`
    border: 1px solid #3e3e47;
    border-radius: 4px;
    height: 44px;
    padding: 0 24px;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 8px;
    position: relative;
    width: 241px;
  `;

  return (
    <PrintInvoiceBox onClick={loading ? null : onClick} style={{...buttonStyle, opacity: loading ? 0.5 : 1}}>
      {loading && (
        <Box
          style={{
            position: "absolute",
            width: "100%",
            height: "100%",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Spinner />
        </Box>
      )}
      <IcoMoon
        icon={DownloadIconWMO}
        color="brand"
        size="20px"
        viewBoxProp="0 0 438.533 438.533"
      />
      <Text alignSelf="center" size="small" weight={600} color="border-2">
        Download Invoice
      </Text>
    </PrintInvoiceBox>
  );
};

export default DownloadInvoiceButton;
